/**
 * Created by Carsten Bühler
 * User: CBuehler on 12.02.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

//Includes
import React from 'external/react';
import SubscriptionActions from '../actions/SubscriptionActions';
import { getSubscriptionStore } from '../stores/StoreFactory';
import { AppContext, ContextContainer, DataUtil, FlagComponent, translation } from 'plugin/liferay-widgets-react-web';
import { Table } from 'external/react-bootstrap';
import EditMultiUserSubscriptionButton from '../components/EditMultiSubscriptionButton';
import '../css/_notifications.scss';

const SubscriptionStore = getSubscriptionStore(AppContext);

const SUBSCRIPTION_OPTIONS = {
    'push': 'Push',
    'email': 'E-Mail',
};

const parseSubscriptionChannels = (keys) => {
    return Array.from(keys).map(k => SUBSCRIPTION_OPTIONS[k]).join(', ');
};

class UserSubscriptions extends React.Component {
    constructor(props) {
        super(props);
        this.DATA = {
            USER_SUBSCRIPTIONS: 'userSubscriptions',
            EDIT_SUBSCRIPTION_FORM: 'editSubscriptionForm',
            DELETE_SUBSCRIPTION_CONFIRM: 'deleteSubscriptionConfirm',
        };
    }

    static getStores() {
        return [
            SubscriptionStore
        ];
    }

    static calculateState(prevState, undefined, DATA) {
        return {
            userSubscriptions: SubscriptionStore.getRemoteData(DATA.USER_SUBSCRIPTIONS)
        };
    }

    componentDidMount() {
        SubscriptionActions.mySubscriptionsNeeded();
    }

    groupByTopicPrefix(arr) {
        return arr.reduce((acc, obj) => {
            const type = obj.topic.split('#')[0].split('~')[0];
            let name = obj.topic;

            if (name.includes('~')) {
                name = name.substring(0, name.indexOf('~')) + name.substring(name.indexOf('#'));
            }

            if (!acc[type]) {
                acc[type] = [];
            }

            let groupIndex = acc[type].findIndex(group => group.name === name);

            if (groupIndex === -1) {
                acc[type].push({
                    name: name,
                    items: [ obj ]
                });
            } else {
                acc[type][groupIndex].items.push(obj);
            }

            return acc;
        }, {});
    }

    getTopicType(topic) {
        return topic.split('#')[0];
    }

    render() {
        const { userSubscriptions: userSubscriptionsDataItem } = this.state;
        const userSubscriptionsByTopic = userSubscriptionsDataItem ? this.groupByTopicPrefix(DataUtil.asArray(userSubscriptionsDataItem)) : [];

        return (
            <FlagComponent item={userSubscriptionsByTopic}>
                <div className="user-subscriptions">
                    <Table striped bordered condensed hover>
                        <thead>
                        <tr>
                            <th>Titel</th>
                            <th>Ereignisart</th>
                            <th>Kanäle</th>
                            <th>Aktionen</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Object.keys(userSubscriptionsByTopic).length === 0 &&
                            <tr>
                                <td colSpan="4">
                                    Keine Abonnements
                                </td>
                            </tr>
                        }
                        {Object.keys(userSubscriptionsByTopic).map((key) => {
                            const subscriptionByTopic = userSubscriptionsByTopic[key];
                            return (
                                <React.Fragment>
                                    <tr>
                                        <th colSpan="4">{translation.trans(key) + ' '}</th>
                                    </tr>
                                    {subscriptionByTopic.map(multiSubscription => (
                                        <React.Fragment>
                                            <tr>
                                                <td rowSpan={multiSubscription.items.length} className="cell-text-wrap">{multiSubscription.items[0].title}</td>
                                                <td className="cell-text-wrap">{multiSubscription.items.length > 1 ? translation.trans(this.getTopicType(multiSubscription.items[0].topic)) : ''}</td>
                                                <td>{parseSubscriptionChannels(multiSubscription.items[0].channels)}</td>
                                                <td rowSpan={multiSubscription.items.length}>
                                                    <EditMultiUserSubscriptionButton
                                                        title="Bearbeiten"
                                                        objectTitle={multiSubscription.items[0].title}
                                                        topics={[ ...multiSubscription.items.map(sub => sub.topic) ]}
                                                    />
                                                </td>
                                            </tr>
                                            {multiSubscription.items.map((item, index) => (
                                                index > 0 && <tr>
                                                    <td className="cell-text-wrap">{translation.trans(this.getTopicType(item.topic))}</td>
                                                    <td>{parseSubscriptionChannels(item.channels)}</td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>
            </FlagComponent>
        );
    }
}

UserSubscriptions.propTypes = {};

export default ContextContainer.create(UserSubscriptions);



// WEBPACK FOOTER //
// ./js/widgets/UserSubscriptions.jsx